import React, { useState } from 'react';
import { useNavigation } from 'context/NavigationContext';
import {
    BringzzPageContainer, BringzzIcon, BringzzRangePicker, BringzzAccordion, BringzzRadioList, BringzzRadio, BringzzText, BringzzCheckbox, BringzzInput, BringzzButton
} from "@bringzz/components";
import { useTranslation } from 'react-i18next';

let state = {
    checked: (
        <BringzzIcon
            icon="IconCheck"
            library="Custom"
            className="h-5 w-5 p-1 bg-magic-lilac text-light rounded-full"
            size="12"
        />
    ),
    unChecked: (
        <div></div>
    ),
};

const SearchFilterPage = ({ onFiltersChange, initialFilters = {} }) => {
    const { t } = useTranslation();
    const { backPress } = useNavigation();
    const { navigate } = useNavigation();
    const [priceRange, setPriceRange] = useState([0, 100]);
    const [sortBy, setSortBy] = useState(initialFilters.sortBy || '');

    const [filters, setFilters] = useState(initialFilters);

    const handlePriceRangeChange = (range) => {
        setPriceRange(range);
    };

    return (
        <BringzzPageContainer
            className="bg-white pb-32"
            authenticated={false}
            header={{
                title: t('component.search.filters.title'),
                right: <BringzzIcon
                    size="22"
                    icon="IconClose"
                    folder="LineIcons"
                    className="cursor-pointer"
                    onClick={backPress}
                />,
            }}
        >
            <div className='px-6'>
                <div>
                    <BringzzAccordion title={t('component.search.filters.sort_by')} defaultValue={true}>
                        <BringzzRadioList state={state} value={sortBy} onChange={setSortBy}>
                            <BringzzRadio value={"name_asc"}><BringzzText tag='h4' className='font-normal'>Name A-Z</BringzzText></BringzzRadio>
                            <BringzzRadio value={"name_desc"}><BringzzText tag='h4' className='font-normal'>Name Z-A</BringzzText></BringzzRadio>
                            <BringzzRadio value={"price_asc"}><BringzzText tag='h4' className='font-normal'>Price Low to High</BringzzText></BringzzRadio>
                            <BringzzRadio value={"price_desc"}><BringzzText tag='h4' className='font-normal'>Price High to Low</BringzzText></BringzzRadio>
                            <BringzzRadio value={"pzn"}><BringzzText tag='h4' className='font-normal'>PZN</BringzzText></BringzzRadio>
                        </BringzzRadioList>
                    </BringzzAccordion>
                </div>
                <div>
                    <BringzzAccordion title={t('component.search.filters.availability.title')} defaultValue={true}>
                        <BringzzCheckbox label={t('component.search.filters.availability.ready_to_order')} />
                        <BringzzCheckbox label={t('component.search.filters.availability.available')} />
                        <BringzzCheckbox label={t('component.search.filters.availability.not_available')} />
                    </BringzzAccordion>
                </div>
                <div>
                    <BringzzAccordion title={t('component.search.filters.sales.title')} defaultValue={true}>
                        <BringzzCheckbox label={t('component.search.filters.sales.ready_to_order')} />
                        <BringzzCheckbox label={t('component.search.filters.sales.available')} />
                    </BringzzAccordion>
                </div>

                <div>
                    <BringzzAccordion title={t('component.search.filters.price.title')} defaultValue={true}>
                        <BringzzRangePicker
                            min={0}
                            max={100}
                            step={1}
                            onChange={handlePriceRangeChange}
                        />
                        <BringzzCheckbox label={t('component.search.filters.price.range_1')} />
                        <BringzzCheckbox label={t('component.search.filters.price.range_2')} />
                        <BringzzCheckbox label={t('component.search.filters.price.range_3')} />
                        <BringzzCheckbox label={t('component.search.filters.price.range_4')} />
                    </BringzzAccordion>
                </div>
                <div>
                    <BringzzAccordion title={t('component.search.filters.application_form.title')} defaultValue={true}>
                        <BringzzCheckbox label={t('component.search.filters.application_form.tablets', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.application_form.dragees', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.application_form.capsules', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.application_form.soluble_tablet', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.application_form.chewable_tablet', { count: 'XX' })} />
                    </BringzzAccordion>
                </div>
                <div>
                    <BringzzAccordion title={t('component.search.filters.pack_sizes.title')} defaultValue={true}>
                        <BringzzCheckbox label={t('component.search.filters.pack_sizes.size_1', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.pack_sizes.size_2', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.pack_sizes.size_3', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.pack_sizes.size_4', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.pack_sizes.size_5', { count: 'XX' })} />
                    </BringzzAccordion>
                </div>
                <div>
                    <BringzzAccordion title={t('component.search.filters.active_ingredients.title')} defaultValue={true}>
                        <BringzzCheckbox label={t('component.search.filters.active_ingredients.ingredient_1', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.active_ingredients.ingredient_2', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.active_ingredients.ingredient_3', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.active_ingredients.ingredient_4', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.active_ingredients.ingredient_5', { count: 'XX' })} />
                    </BringzzAccordion>
                </div>
                <div>
                    <BringzzAccordion title={t('component.search.filters.manufacturer.title')} defaultValue={true}>
                        <BringzzCheckbox label={t('component.search.filters.manufacturer.manufacturer_1', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.manufacturer.manufacturer_2', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.manufacturer.manufacturer_3', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.manufacturer.manufacturer_4', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.manufacturer.manufacturer_5', { count: 'XX' })} />
                    </BringzzAccordion>
                </div>
                <div>
                    <BringzzAccordion title={t('component.search.filters.brands.title')} defaultValue={true}>
                        <BringzzCheckbox label={t('component.search.filters.brands.brand_1', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.brands.brand_2', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.brands.brand_3', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.brands.brand_4', { count: 'XX' })} />
                        <BringzzCheckbox label={t('component.search.filters.brands.brand_5', { count: 'XX' })} />
                    </BringzzAccordion>
                </div>
            </div>
            <div className="px-6 py-4 border-t bg-white fixed bottom-0 left-0 right-0">
                <BringzzButton
                    className="w-full bg-magic-lilac"
                    onClick={() => {
                        const newFilters = {
                            sortBy: sortBy
                        };
                        if (onFiltersChange) {
                            onFiltersChange(newFilters);
                        }
                        backPress();
                    }}
                >
                    Apply Filters
                </BringzzButton>
            </div>
        </BringzzPageContainer>
    );
};

export default SearchFilterPage;
